import React, { useEffect, useState } from 'react';
import './BouncingDuck.css';

interface Duck {
  id: number;
  x: number;
  y: number;
}

const BouncingDuck: React.FC = () => {
  const [ducks, setDucks] = useState<Duck[]>([]);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const newDuck: Duck = {
        id: Date.now(),
        x: e.clientX - 25,
        y: e.clientY - 25,
      };
      
      setDucks(prev => [...prev, newDuck]);

      setTimeout(() => {
        setDucks(prev => prev.filter(duck => duck.id !== newDuck.id));
      }, 1000);
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return (
    <>
      {ducks.map(duck => (
        <img
          key={duck.id}
          src="/assets/images/duck1.png"
          alt="Bouncing Duck"
          className="bouncing-duck"
          style={{
            left: `${duck.x}px`,
            top: `${duck.y}px`,
          }}
        />
      ))}
    </>
  );
};

export default BouncingDuck;
